import { LanguageCodes } from "@/core/types/LanguageTypes";
import { CurrencyTypes } from "@/core/types/CurrencyTypes";
import moment from "moment";

const filters = {
  toCurrency: (value: number, currencyId = 840, locale = "en-US") => {
    const currencyCode = CurrencyTypes[currencyId]
      ? CurrencyTypes[currencyId]
      : "USD";

    // Use appropriate locale for currency symbol display
    // For JPY, use ja-JP locale to show ¥ symbol
    // For other currencies, use the provided locale
    let displayLocale = locale;
    if (currencyCode === "JPY" && !locale.startsWith("ja")) {
      displayLocale = "ja-JP";
    } else if (currencyCode === "CNY" && !locale.startsWith("zh")) {
      displayLocale = "zh-CN";
    } else if (currencyCode === "KRW" && !locale.startsWith("ko")) {
      displayLocale = "ko-KR";
    }

    return new Intl.NumberFormat(
      LanguageCodes.activated.includes(displayLocale)
        ? displayLocale
        : LanguageCodes.enUS,
      {
        style: "currency",
        currency: currencyCode,
      }
    ).format(value / 100);
  },

  toDateTime: (value: number, locale = "en-US") =>
    moment(value)
      .locale(
        LanguageCodes.activated.includes(locale) ? locale : LanguageCodes.enUS
      )
      .format("l LT"),

  getDateAndTimeFromISOString: (
    dateIsoString: string,
    format?: string,
    locale = "en-US"
  ) => {
    const date = moment(dateIsoString).locale(locale);

    if (date.year() === 1970 || date.year() === 1969) {
      return "-";
    }

    if (format) {
      return date.format(format);
    }
    if (date.year() === moment().year()) {
      return date.format("MM-DD HH:mm:ss");
    }
    return date.format("YYYY-MM-DD HH:mm:ss");
  },
};
export default filters;
